<script setup lang="ts">
import {
  SoccerEventStatusId,
  SoccerIncidentId,
} from '@collector/sportsapi-client-legacy'
import BetButton from '@desktop/views/Relation/Sports/components/RelationView/Main/PocketIncidents/BetButton/BetButton.vue'

const disabledStatuses = new Set([
  SoccerEventStatusId.NotStarted,
  SoccerEventStatusId.StartDelayed,
  SoccerEventStatusId.Postponed,
  SoccerEventStatusId.Abandoned,
  SoccerEventStatusId.Cancelled,
])
</script>

<template>
  <BetButton
    class="min-w-31"
    betMarketEventKey="bet_cards"
    betStatusActiveText="Close cards"
    betStatusInactiveText="Open cards"
    :openMarketsIncidentId="SoccerIncidentId.BookingMarketsEnabled"
    :closeMarketsIncidentId="SoccerIncidentId.BookingMarketsDisabled"
    :disabledStatuses
  >
    <img
      class="h-3.5 w-3.5"
      src="./card.svg"
    />
  </BetButton>
</template>
